import { render, staticRenderFns } from "./headerMob.vue?vue&type=template&id=40c2b64c&scoped=true"
import script from "./headerMob.vue?vue&type=script&lang=js"
export * from "./headerMob.vue?vue&type=script&lang=js"
import style0 from "./headerMob.vue?vue&type=style&index=0&id=40c2b64c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c2b64c",
  null
  
)

export default component.exports